import React from "react";
//#region types
import { ActionButtonProps } from "models/propTypes/actionButtonPropTypes";
//#endregion
//#region components
import { ButtonBase, Grid } from "@mui/material";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ActionButton: React.FC<ActionButtonProps> = (props) => {
  return (
    <ButtonBase component="div" className={cssExports.actionButton} onClick={props.onClickHandler}>
      <Grid container direction={"column"} spacing={2}>
        <Grid item>
          <Icon className={cssExports.actionIcon} icon={props.icon} />
        </Grid>
        <Grid item className={cssExports.actionButtonText}>
          {LocalizationHelperInstance.getFormattedMessage(props.btnText)}
        </Grid>
      </Grid>
    </ButtonBase>
  );
};

export default ActionButton;
